export const theme = {
  colors: {
    textDefault: '#111111',
    textLight: '#999999',
    primary: '#1CA1F1',
    primaryLight: '#3FACFC',
    surface: '#DADADA',
    surfaceLight: '#FEFEFE',
  }
};